export function formatRegistrationNumber(reg: string) {
  return reg.replace(/\s/g, "");
}
